module.exports = __webpack_public_path__ + "static/media/Makita.79f7c482.png";